import dayjs from '@/config/dayjs';
import { API_DATE_FORMAT } from '@/constants/dateFormats';

const ExportUtility = () => {
  /**
   * @param fileName - Generally the name of the grid or page.
   */
  const generateFileName = (fileName: string) => {
    const name = fileName.replace(/[\\/:*?"<>|\s]+/g, '') || 'export';
    return `${name}_${dayjs().format(API_DATE_FORMAT)}`;
  };

  return {
    generateFileName,
  };
};

export default ExportUtility();
